module.exports = __webpack_public_path__ + "static/18-e01c6e89177c1edf7a5ff73b3e77e644.jpeg";